import React from "react"
import { Container } from "reactstrap"
import { Dashboard } from "../Dashboard/Dashboard"
import SecondaryNav from "../SubNavigation"
import Layout from "../Layout"
import Modal from "./Modal"
import { COACH_TOOLS_API } from "../../apolloClient"
import { gql, useQuery } from "@apollo/client"
import { get } from "lodash"
import { LoadingComponent } from "@pga/pga-component-library"

export const TERMINATED_DUES_CYCLE_QUERY = gql`
  query TerminatedDuesCycleQuery {
    duesCycle: currentDuesCycle {
      id
      dueDate
      endsOn
      order {
        id
        balance
        dueDate
        stage
        payable
        pdfAvailable
        lineItems {
          id
          name
        }
      }
    }
  }
`

export const TERMINATED_ORDERS_QUERY = gql`
  query TerminatedOrdersQuery {
    currentPerson {
      id
      orders {
        id
        balance
        orderType
        status
        payable
        lineItems {
          id
          name
        }
      }
    }
  }
`

const TerminatedWrapper = ({ me }) => {
  const { data: duesData, loading: duesLoading } = useQuery(
    TERMINATED_DUES_CYCLE_QUERY,
    {
      fetchPolicy: "cache-and-network",
      context: { api: COACH_TOOLS_API },
    },
  )
  const { data: ordersData, loading: ordersLoading } = useQuery(
    TERMINATED_ORDERS_QUERY,
    {
      fetchPolicy: "cache-and-network",
      context: { api: COACH_TOOLS_API },
    },
  )

  if (duesLoading || ordersLoading) return <LoadingComponent />

  return (
    <div style={{ height: "80vh" }}>
      <Layout>
        <>
          <SecondaryNav />
          <Container>
            <Modal
              me={me}
              duesCycle={get(duesData, "duesCycle")}
              orders={get(ordersData, "currentPerson.orders", [])}
            />
            <section>
              <Dashboard me={me} authReady />
            </section>
          </Container>
        </>
      </Layout>
    </div>
  )
}
export default TerminatedWrapper
